import CurrencyValueUIModel from './currency-value';

class CHUBBPricesPerPasseger {
  constructor({
    currency = undefined,
    passengerId = '',
  } = {}) {
    this.currency = new CurrencyValueUIModel(currency);
    this.passengerId = passengerId;
  }
}

export default CHUBBPricesPerPasseger;
